import { EmojiEventsOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import { useMemo } from 'react';

type LoyaltyChipsProps = {
  customer: Partial<Customer>;
};

const LoyaltyChips = ({ customer }: LoyaltyChipsProps) => {
  const loyaltyTiers = useMemo(() => {
    if (!customer?.extendedAttributes) return [];

    return Object.keys(customer?.extendedAttributes).reduce((acc, key) => {
      const match = key.match(/^SEG_(.*)_LOYALTY_TIER$/);
      if (match) {
        acc.push(match[1].split('_').join(' ').toLowerCase());
      }
      return acc;
    }, []);
  }, [customer?.extendedAttributes]);

  return (
    <>
      {loyaltyTiers.map(tier => (
        <Chip
          key="label"
          label={tier}
          color="primary"
          size="small"
          data-testid="loyaltyTierLabel"
          sx={{ mr: 1, textTransform: 'capitalize' }}
          icon={<EmojiEventsOutlined sx={{ '&&': { ml: '5px' } }} />}
        />
      ))}
    </>
  );
};
export default LoyaltyChips;
